export interface ApiError {
  code: string;
  message: string;
  details?: Array<{
    field: string;
    message: string;
  }>;
}

export interface ApiResponse<T> {
  data?: T;
  error?: ApiError;
}

export interface DeleteResponse {
  message: string;
  id: string;
}

export class APIError extends Error {
  public code: string;
  public details?: Array<{
    field: string;
    message: string;
  }>;

  constructor(error: ApiError) {
    super(error.message);
    this.name = 'APIError';
    this.code = error.code;
    this.details = error.details;
  }
}